var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.smsCampaign)?_c('div',{staticClass:"space-y-8"},[_c('EditSmsCampaignForm',{attrs:{"sms-campaign":_vm.smsCampaign}}),(_vm.canDelete)?_c('DeleteSmsCampaign',{attrs:{"sms-campaign":_vm.smsCampaign}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }